import React,{useState} from 'react'
import { LockClosedIcon } from '@heroicons/react/20/solid'
import { useForm } from "react-hook-form";
import {
  useLocation,
  useNavigate
} from 'react-router-dom';
import { ThemeColor } from '../../utilities/theme.color';

import theme from '../../constants/app.theme'


function RegisterPage() {
  const { register, handleSubmit, watch, formState: { errors } } = useForm();
  const onSubmit = data => console.log(data);

  const [hidePassword, setHidePassword] = useState(true)

  const navigate = useNavigate()


  console.log(errors, 'errors')

  console.log(watch("password")); // watch input value by passing the name of it

  const toggle_hide_password = () => {
    setHidePassword(!hidePassword)
  }
  
  const redirectToLoginPage = () => {
    navigate('/login')
  }

  console.log(errors, 'errors')

  console.log(watch("password")); // watch input value by passing the name of it
  return (
    <>
      <div className="flex min-h-full items-center justify-center sm:px-6 lg:px-8 dark:bg-black py-5">
        <div className="w-full max-w-md space-y-8">
          <div>
            <img
              className="mx-auto h-12 w-auto"
              src={`https://tailwindui.com/img/logos/mark.svg?color=teal&shade=600`}
              alt="Your Company"
            />
            <h2 className="mt-6 text-center text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
              WORKSHOP MANAGEMENT SYSTEM
            </h2>
            {/*<p className="mt-2 text-center text-sm text-gray-600">
              Or{' '}
              <a href="#" className="font-medium text-${theme.bg_color}-600 hover:text-${theme.bg_color}-500">
                start your 14-day free trial
              </a>
            </p>*/}
          </div>

          <div className='bg-white rounded-md shadow-md p-10'>
            <form className="" onSubmit={handleSubmit(onSubmit)}>
              <div className="">
                <div className='mb-2'>
                  <label htmlFor="company-name" className='text-sm'>
                    Company Name
                  </label>
                  <input
                    id="company-name"
                    name="company_name"
                    type="text"
                    {...register("company_name", { required: true })}
                    autoComplete="company_name"
                    className={`relative block w-full appearance-none rounded-md border border-${errors.company_name ? "red" : "gray"}-700 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-${errors.company_name ? "red" : "theme_color"}-500 focus:outline-none focus:ring-${errors.company_name ? "red" : "theme_color"}-500 sm:text-sm mb-1 ${errors.company_name && "error-input"}`}
                    placeholder=""
                  />
                  {errors.company_name && <span className='text-xs text-red-700'>This field is required</span>}
                </div>
                <div className='mb-2'>
                  <label htmlFor="first_name" className="text-sm">
                    User First Name
                  </label>
                  <input
                    id="first_name"
                    name="first_name"
                    {...register("first_name", { required: true })}
                    type="text"
                    autoComplete="first_name"
                    className={`relative block w-full appearance-none rounded-md border border-${errors.first_name ? "red" : "gray"}-700 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-${errors.first_name ? "red" : "theme_color"}-500 focus:outline-none focus:ring-${errors.first_name ? "red" : "theme_color"}-500 sm:text-sm mb-1 ${errors.first_name && "error-input"}`}
                    placeholder=""
                  />
                  {errors.first_name && <span className='text-xs text-red-700'>This field is required</span>}
                </div>
                <div className='mb-2'>
                  <label htmlFor="first_name" className="text-sm">
                    User Last Name
                  </label>
                  <input
                    id="last_name"
                    name="last_name"
                    {...register("last_name", { required: false })}
                    type="text"
                    autoComplete="last_name"
                    className={`relative block w-full appearance-none rounded-md border border-${errors.last_name ? "red" : "gray"}-700 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-${errors.last_name ? "red" : "theme_color"}-500 focus:outline-none focus:ring-${errors.last_name ? "red" : "theme_color"}-500 sm:text-sm mb-1 ${errors.last_name && "error-input"}`}
                    placeholder=""
                  />
                  {errors.last_name && <span className='text-xs text-red-700'>This field is required</span>}
                </div>
                <div className='mb-2'>
                  <label htmlFor="email-address" className="text-sm">
                    Email Address
                  </label>
                  <input
                    id="email-address"
                    name="email"
                    type="email"
                    {...register("email", { required: true })}
                    autoComplete="email"
                    className={`relative block w-full appearance-none rounded-md border border-${errors.email ? "red" : "gray"}-700 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-${errors.email ? "red" : "theme_color"}-500 focus:outline-none focus:ring-${errors.email ? "red" : "theme_color"}-500 sm:text-sm mb-1 ${errors.email && "error-input"}`}
                    placeholder=""
                  />
                  {errors.email && <span className='text-xs text-red-700'>This field is required</span>}
                </div>
                <div className='mb-2'>
                  <label htmlFor="password" className="text-sm">
                    Password
                  </label>
                  <input
                    id="password"
                    name="password"
                    {...register("password", { required: true })}
                    type={hidePassword ? "password" : "text"}
                    autoComplete="current-password"
                    className={`relative block w-full appearance-none rounded-md border border-${errors.password ? "red" : "gray"}-700 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-${errors.password ? "red" : "theme_color"}-500 focus:outline-none focus:ring-${errors.password ? "red" : "theme_color"}-500 sm:text-sm mb-1 ${errors.password && "error-input"}`}
                    placeholder=""
                  />
                  {errors.password && <span className='text-xs text-red-700'>This field is required</span>}
                </div>

                <div className='mb-4'>
                  <label htmlFor="confirm_password" className="text-sm">
                    Confirm Password
                  </label>
                  <input
                    id="confirm_password"
                    name="confirm_password"
                    {...register("confirm_password", { required: true })}
                    type={hidePassword ? "password" : "text"}
                    autoComplete="confirm_password"
                    className={`relative block w-full appearance-none rounded-md border border-${errors.confirm_password ? "red" : "gray"}-700 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-${errors.confirm_password ? "red" : "theme_color"}-500 focus:outline-none focus:ring-${errors.confirm_password ? "red" : "theme_color"}-500 sm:text-sm mb-1 ${errors.confirm_password && "error-input"}`}
                    placeholder=""
                  />
                  {errors.confirm_password && <span className='text-xs text-red-700'>This field is required</span>}
                </div>
              </div>

              <div className="flex items-center justify-between mt-6 mb-6">
                <div className="flex items-center">
                  <input
                    id="show-password"
                    name="show-password"
                    type="checkbox"
                    defaultChecked={!hidePassword}
                    onChange={() => toggle_hide_password()}
                    className={`h-4 w-4 rounded border-gray-300 text-theme_color-600 ring-theme_color-500 focus:ring-theme_color-500 focus:ring-offset-2`}
                  />
                  <label htmlFor="show-password" className="ml-2 block text-sm text-gray-900">
                    Show Password
                  </label>
                </div>

                <div className="text-sm">
                  <a href="#" className={`font-medium text-theme_color-600 hover:text-theme_color-500`}>
                    Forgot your password?
                  </a>
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  className={`group relative flex w-full justify-center rounded-md border border-transparent bg-theme_color-600 py-2 px-4 text-sm font-medium text-white hover:bg-theme_color-700 focus:outline-none focus:ring-2 ring-theme_color-500 focus:ring-theme_color-500 focus:ring-offset-2`}
                >
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                    <LockClosedIcon className={`h-5 w-5 text-theme_color-500 text group-hover:text-theme_color-400 aria-hidden="true"`} />
                  </span>
                  Sign Up
                </button>
              </div>

              <div className='flex align-middle justify-center mt-3'>
                <div className="text-sm">
                  Already have account? &nbsp;
                  <a onClick={() => redirectToLoginPage()} className={`font-medium text-theme_color-600 hover:text-theme_color-500 cursor-pointer`}>
                    Login
                  </a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default RegisterPage